var _path, _rect, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMoreCoachingTeam = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21,13.03c.04,.24,.1,.48,.17,.71-.13,.03-.26,.05-.4,.05-.94,0-1.71-.78-1.71-1.74s.77-1.74,1.71-1.74c.14,0,.27,.02,.4,.05-.07,.23-.13,.47-.17,.71-.07-.02-.15-.03-.23-.03-.55,0-.99,.45-.99,1.01s.45,1.01,.99,1.01c.08,0,.15-.01,.22-.03Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.13,
    y: 6.98,
    width: 1.69,
    height: 1.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67,9.46c-1.43,0-2.6,1.16-2.6,2.59s1.16,2.6,2.6,2.6,2.59-1.16,2.59-2.6-1.16-2.59-2.6-2.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36,6.98v1.34c0,.19-.15,.35-.34,.35h-2.09c-.19,0-.34-.16-.34-.35v-1.34h-3.78c-2.76,0-5.02,2.12-5.14,4.83-.07,1.41,.42,2.74,1.38,3.76,.95,1.01,2.24,1.57,3.62,1.57,2.73,0,4.97-2.26,5-5.03,0-.15,.09-.27,.22-.32l7.55-2.89,.28-1.92h-6.37ZM7.67,15.19c-1.71,0-3.1-1.41-3.1-3.14s1.39-3.14,3.1-3.14,3.1,1.41,3.1,3.14-1.39,3.14-3.1,3.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97,5.06c.2,0,.36-.16,.36-.36v-1.44c0-.2-.16-.36-.36-.36s-.36,.16-.36,.36v1.44c0,.2,.16,.36,.36,.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17,5.64c.07,.11,.18,.17,.3,.17,.07,0,.13-.02,.19-.06,.17-.11,.22-.33,.11-.5l-.72-1.14c-.11-.17-.33-.22-.5-.11-.17,.11-.22,.33-.11,.5l.72,1.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.24,5.85c.06,.04,.13,.06,.19,.06,.12,0,.23-.06,.3-.17l.72-1.14c.11-.17,.06-.39-.11-.5-.17-.11-.39-.06-.5,.11l-.72,1.14c-.11,.17-.06,.39,.11,.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMoreCoachingTeam, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_Coaching Team.85a2b7a3.svg";
export { ForwardRef as ReactComponent };